module.exports = __webpack_public_path__ + "static/media/dog2-icon.7ee79b34.jpg";